const DAY = String.raw`(?:day|dia|d[ií]a|jour)`
const NUM = String.raw`(?:\d+(?:[ \t]*[/+][ \t]*\d+){0,3}[º°]?|[#＃]\d+|n[°º]\d+|[Jj]-\d+)`
const SEP = String.raw`[\s:.\-–—|,/−_;|\]]`

const dayPrefixRegex = new RegExp(String.raw`^[^\p{L}]*${DAY}\s+${NUM}(?:${SEP}+|(?=[^\p{L}\p{N}]))`, 'iu')

export const removeDayPrefix = (title: string) => {
  const result = title.replace(dayPrefixRegex, '')

  return result || title
}
